import { observeElement, loadScripts } from '@uvocore-front/utils';
import { tns } from 'tiny-slider/src/tiny-slider';

import '../../components/ImagesLazyLoading';
import '../../components/VideoLazyLoading';

import './components/AnimationHIW';

import Accordion from '../../all_pages/js/components/Accordion';
import stickyHeaderInit from '../../all_pages/js/components/sticky-header';
import mobileNavigationInit from '../../all_pages/js/components/mobile-nav';
import navDropdownInit from '../../all_pages/js/components/dropdowns';

import SliderSplide from './components/SliderSplide';

observeElement({
  element: '.section-cheap-writers',
  marginValue: 100,
  callback: () => {
    tns({
      container: '.cheap-writers-slider',
      slideBy: 1,
      autoplayHoverPause: true,
      mouseDrag: true,
      autoplay: false,
      autoplayButtonOutput: false,
      loop: false,
      responsive: {
        0: {
          controls: false,
          items: 1,
          nav: true,
        },
        1000: {
          items: 2,
          gutter: 0,
          controls: true,
        },
        1170: {
          items: 3,
          gutter: 0,
          controls: false,
          nav: false,
        },
      },
    });
  },
});

observeElement({
  element: '.testimonials-slider',
  marginValue: 400,
  callback: () => {
    // eslint-disable-next-line no-unused-vars
    tns({
      container: '.testimonials-slider',
      slideBy: 1,
      autoplayHoverPause: true,
      mouseDrag: true,
      autoplay: false,
      autoplayButtonOutput: false,
      loop: false,
      responsive: {
        0: {
          controls: false,
          gutter: 0,
          items: 1,
          nav: true,
        },
        1000: {
          items: 2,
          gutter: 30,
          controls: true,
        },
        1170: {
          items: 3,
          gutter: 30,
        },
      },
    });
  },
});

observeElement({
  element: '[data-writers]',
  marginValue: 300,
  callback: () => {
    SliderSplide('[data-writers]', {
      loop: false,
      type: 'slider',
      mediaQuery: 'min',
      gap: '24px',
      arrows: false,
      pagination: true,
      breakpoints: {
        1024: {
          destroy: true,
        },
        768: {
          perPage: 2,
        },
        640: {
          perPage: 1,
        },
      },
    }).mount();
  },
});

observeElement({
  element: '.accordion',
  marginValue: 400,
  callback: () => {
    Accordion();
  },
});

window.addEventListener('load', () => {
  stickyHeaderInit();
  mobileNavigationInit();

  if (document.querySelector('.nav')) {
    navDropdownInit();
  }

  // Add attribute to facebook messenger btn
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  if (!isMobile) {
    const fbChatBtns = document.querySelectorAll('[data-messenger]');

    [...fbChatBtns].forEach((btn) => {
      btn.setAttribute('target', '_blank');
    });
  }

  if (isMobile) document.documentElement.classList.add('is-touch-device');
});
